// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__ifR1J","btn__Loader":"button_btn__Loader__Bw6Qr","btn__inactive":"button_btn__inactive__wyNBr"};